import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

/**
 * JInspectorTitleBar — draggable titlebar with save/cancel actions.
 * @param {string} rkPrefix - first 8 chars of entry rk
 * @param {boolean} isDirty - controls save icon color and cursor
 * @param {boolean} dragging - controls grab cursor
 * @param {Function} onDragStart - mousedown handler
 * @param {Function} onSave
 * @param {Function} onCancel
 */
export default function JInspectorTitleBar({ rkPrefix, isDirty, dragging, onDragStart, onSave, onCancel }) {
    return (
        <div className="j-inspector-titlebar" onMouseDown={onDragStart} style={{ cursor: dragging ? 'grabbing' : 'grab' }}>
            <EditIcon sx={{ fontSize: 13, color: '#a3d1ff', mr: '6px' }} />
            <span>JInspector - Edit note · {rkPrefix}</span>
            <div className="j-inspector-titlebar-actions">
                <CheckIcon
                    sx={{ fontSize: 16, cursor: isDirty ? 'pointer' : 'default', color: isDirty ? '#4caf8a' : '#294766' }}
                    onClick={onSave}
                />
                <CloseIcon sx={{ fontSize: 16, cursor: 'pointer', color: '#a3d1ff' }} onClick={onCancel} />
            </div>
        </div>
    );
}
